import { useMediaQuery } from './useMediaQuery'

/**
 * True si l'OS demande de réduire les animations. Les `<animate>` SMIL ne sont
 * PAS coupés par le `@media (prefers-reduced-motion)` CSS, donc les couches SVG
 * animées doivent se gater sur ce hook en JS. Défaut false (animations OK).
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)', false)
}
